import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { IonicStorageModule, Storage } from '@ionic/storage-angular';
import { environment } from 'src/environments/environment';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import { routes } from './app.routes';
import { apiInterceptor } from './interceptors/api.interceptor';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import {
    provideAuth,
    initializeAuth,
    indexedDBLocalPersistence,
    getAuth
} from '@angular/fire/auth';

const TOKEN_KEY = 'access_token';

export function jwtOptionsFactory(storage: Storage) {
    return {
        tokenGetter: async () => {
            try {
                return await storage.get(TOKEN_KEY);
            } catch (error) {
                console.error(error);
                return;
            }
        },
        allowedDomains: environment.allowedDomains,
        disallowedRoutes: environment.disallowedRoutes,
    };
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideIonicAngular(),
        provideRouter(routes, withPreloading(PreloadAllModules)),
        provideHttpClient(withInterceptors([apiInterceptor])),
        importProvidersFrom(
            IonicStorageModule.forRoot(),
            JwtModule.forRoot({
                jwtOptionsProvider: {
                    provide: JWT_OPTIONS,
                    useFactory: jwtOptionsFactory,
                    deps: [Storage]
                }
            })
        ),

        // ✅ Inizializza UNA sola app Firebase (modular)
        provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),

        // ✅ Inizializza Auth UNA sola volta con persistenza esplicita
        provideAuth(() => {
            const app = getApp();
            try {
                // Su Capacitor: indexedDBLocalPersistence
                return initializeAuth(app, { persistence: indexedDBLocalPersistence });
            } catch {
                // Fallback Web
                return getAuth(app);
            }
        }),
    ]
};
